import { useEffect, useRef } from 'react';

export function useOnFocusOrClickOutside<
  T extends HTMLElement = HTMLDivElement,
>(handler: (event: Event) => void) {
  const ref = useRef<T>(null);

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        handler(event);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('focusin', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('focusin', handleClickOutside);
    };
  }, [ref, handler]);

  return ref;
}
